import useQuery, { useRevalidate } from "./useQuery";
import { useChannel } from "./ws/useChannel";
import useDebouncedCallback from "@ui/lib/hooks/useDebouncedCallback";

const PATH = "/projects/:projectId(uuid)/analyses/power-output";
function useListPowerOutputs(projectId: string, from: Date, to: Date) {
  const revalidate = useRevalidate();
  const callback = useDebouncedCallback(
    () => {
      void revalidate(PATH, { projectId });
    },
    [revalidate, projectId],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );

  useChannel({ key: "all_analyses", projectId }, callback, true);

  const powerOutputs = useQuery(PATH, {
    routeParams: { projectId },
    query: {
      from,
      to,
    },
    keepPreviousData: true,
  }).body.result;

  return powerOutputs;
}

export default useListPowerOutputs;
